import {IRegisterExtendedWithoutMarketing} from "../types/IRegisterExtendedWithoutMarketing";

export const registerFormExtendedWithoutMarketingValues: IRegisterExtendedWithoutMarketing = {
    name: "",
    email: "",
    phone: {code: 48, number: ""},
    marketing_email: false,
    marketing_sms: false
};
import {IRegisterExtendedWithoutMarketing} from "../types/IRegisterExtendedWithoutMarketing";

export const registerFormExtendedWithoutMarketingValues: IRegisterExtendedWithoutMarketing = {
    name: "",
    email: "",
    phone: {code: 48, number: ""},
    marketing_email: false,
    marketing_sms: false
};
